import { PLANS } from '../../../../features/Billing/plans';
import { goToCheckout } from '../../../../services/GoTo';
import { trackEvent } from '../../../../services/Tracking';
import Button from '../../../Button';
import { CardPlan } from './CardPlan';
import styles from './styles.m.less';

interface UpgradePlanContentProps {
    currentPlan?: number | null;
}

const UpgradePlanContent = ({ currentPlan }: UpgradePlanContentProps) => {
    const handleUpgradeClick = () => {
        trackEvent({
            category: 'upselling',
            action: 'clicked upgrade',
            label: 'clicked upgrade your plan in modal',
        });
        goToCheckout();
    };

    return (
        <div className={styles.container}>
            <p className={styles.subTitle}>Upgrade to unlock access</p>
            <div className={styles.cardsContainer}>
                {PLANS.map(plan => {
                    return (
                        <CardPlan
                            key={plan.id}
                            plan={plan}
                            className={currentPlan === plan.id ? styles.currentPlan : styles.upgradePlan}
                        />
                    );
                })}
            </div>

            <div className={styles.buttonContainer}>
                <Button onClick={handleUpgradeClick} kind="PRIMARY">
                    Upgrade your plan
                </Button>
                <small>Click the button to learn more, you won't be charged yet</small>
            </div>
        </div>
    );
};

export default UpgradePlanContent;
